import { STATS, MANIFESTO, TRUST } from "@/data/content";
import { Reveal } from "@/components/site/Motion";

export default function About() {
  return (
    <section id="about" className="bg-brand-green text-brand-cream">
      {/* Stats bar */}
      <div className="border-b border-brand-cream/15">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 grid grid-cols-2 lg:grid-cols-4">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.05}
              className="py-10 px-2 border-brand-cream/15 [&:not(:nth-child(2n))]:border-r lg:[&:not(:nth-child(4n))]:border-r">
              <div className="font-serif text-5xl sm:text-6xl text-brand-sand">{s.value}</div>
              <div className="mt-2 font-mono text-[10px] uppercase tracking-[0.2em] text-brand-cream/70">{s.label}</div>
            </Reveal>
          ))}
        </div>
      </div>

      {/* Manifesto */}
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-24 sm:py-32 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <Reveal>
            <span className="overline text-brand-sand">Our story</span>
            <h2 className="font-serif text-4xl sm:text-5xl mt-4 leading-tight">
              A Baton Rouge agency built on <span className="italic text-brand-sand">handshakes.</span>
            </h2>
            <p className="mt-6 text-brand-cream/75 leading-relaxed">
              Doug Jones opened these doors to do insurance differently — local, honest, and personal.
              Two decades later, that hasn't changed. We're the people you'll see at the grocery store,
              and the people who pick up when it matters most.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-8 grid sm:grid-cols-2 gap-x-10 gap-y-10">
          {MANIFESTO.map((m, i) => (
            <Reveal key={m.n} delay={i * 0.06} className="border-t border-brand-cream/20 pt-6">
              <div className="font-mono text-sm text-brand-sand">{m.n}</div>
              <h3 className="font-serif text-2xl mt-3">{m.title}</h3>
              <p className="mt-2 text-brand-cream/70 text-sm leading-relaxed">{m.body}</p>
            </Reveal>
          ))}
        </div>
      </div>

      {/* Trust badges */}
      <div className="mx-auto max-w-7xl px-5 sm:px-8 pb-24 sm:pb-32">
        <Reveal className="mb-12">
          <span className="overline text-brand-sand">Why us</span>
          <h2 className="font-serif text-4xl sm:text-5xl mt-4">Local, licensed, independent.</h2>
        </Reveal>
        <div className="grid sm:grid-cols-3 gap-5">
          {TRUST.map((tr, i) => {
            const Icon = tr.icon;
            return (
              <Reveal key={tr.title} delay={i * 0.06}
                className="flex gap-4 rounded-2xl border border-brand-cream/20 p-6">
                <Icon className="h-7 w-7 text-brand-sand shrink-0" />
                <div>
                  <h4 className="font-serif text-xl">{tr.title}</h4>
                  <p className="text-brand-cream/65 text-sm mt-1">{tr.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
